import {appName} from '../settings/constants'
import {createSelector} from 'reselect'
import {Record} from 'immutable'
import RestService from '../helpers/RestService'
import {arrayToMap, arrayPrimitivesToMap, formatErrorMessage, sortCB} from '../helpers/common'
import {CATEGORIES_START, CATEGORIES_SUCCESS, MASS_CATEGORIES_SUCCESS, CATEGORIES_FAIL, CATEGORIES_ENTITIES_CHANGE, CATEGORIES_ENTITIES_DELETE, checkAndUploadCategories, setCategoriesCursor, uncheckCategories} from './categories'
import {SOURCES_START, SOURCES_SUCCESS, SOURCES_FAIL, SOURCES_ENTITIES_CHANGE, SOURCES_ENTITIES_DELETE, MASS_SOURCES_SUCCESS, checkAndUploadSources, clearSourcesCursor} from './sources'
import {TRASHED_QUESTIONS_RECOVER, checkAndUploadGeneralStatistic} from './questions'
import {DISABLED, ENABLED, _getId, _getIds, _trashedScopeCB, _isTrashed, _entities, _entitiesWithTrashed, _getEntity, _getEntityWithTrashed, adjustEntitiesFieldsType} from './_utils'
import { SubmissionError } from 'redux-form'
import {handleTutorialStart} from './tutorial'
import {setQbmNavItem, QBM_NAV_CATEGORIES} from './app'
import {ajaxUrls} from '../settings/routes'

/**
 * Constants
 * */

export const moduleName = 'users'
const prefix = `${appName}/${moduleName}`
const defaultState = {
    list: [],
    isLoading: false,
    total: 0,
    isOpen: false,
}

export const usersReducer = (state = defaultState, action) => {
    const {type} = action;
    switch (type) {
        case 'GET_USERS_LOADING':
            return {
                ...state,
                isLoading: true
            };
        case 'UPDATE_USER_LIST':
            return {
                ...state,
                list: state.list.map(user => {
                    if(user.id == action.user.id){
                        return {...user, ...action.user}
                    }
                    return {...user};
                })
            };    
        case 'GET_USERS_SUCCESS':
            return {
                ...state,
                list: action.list,
                total: action.total,
                isLoading: false
            };
        case 'GET_USERS_FAILURE':
            return {
                ...state,
                isLoading: false
            };
        case 'TOGGLE_USER_MODAL':
            return {
                ...state,
                isOpen: action.show
            };
        case 'CHANGE_USERS_SUCCESS': {
            return {
                ...state,
                list: action.list,
            }
        };
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/modules/users.js